/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type {
  PostUsersResetPasswordVerifyMutationRequest,
  PostUsersResetPasswordVerifyMutationResponse,
  PostUsersResetPasswordVerify400,
} from '../entities/PostUsersResetPasswordVerify'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'

function getPostUsersResetPasswordVerifyUrl() {
  return `/users/reset-password/verify` as const
}

/**
 * @description Подтверждение восстановления пароля
 * @summary Подтверждение восстановления пароля
 * {@link /users/reset-password/verify}
 */
export async function postUsersResetPasswordVerify(
  data: PostUsersResetPasswordVerifyMutationRequest,
  config: Partial<RequestConfig<PostUsersResetPasswordVerifyMutationRequest>> & { client?: typeof client } = {},
) {
  const { client: request = client, ...requestConfig } = config

  const res = await request<
    PostUsersResetPasswordVerifyMutationResponse,
    ResponseErrorConfig<PostUsersResetPasswordVerify400>,
    PostUsersResetPasswordVerifyMutationRequest
  >({ method: 'POST', url: getPostUsersResetPasswordVerifyUrl().toString(), data, ...requestConfig })
  return res.data
}